import BasicInfo from '../../Common/BasicInfo';
import FindCarriers from './FindCarriers';
import PersonalizingOptions from './PersonalizingOptions';
import PersonalHistory from './PersonalHistory';
import PredictiveBasicInfo from './PredictiveBasicInfo';

export {
  PredictiveBasicInfo,
  PersonalHistory,
  PersonalizingOptions,
  FindCarriers,
  BasicInfo,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/PreQuote/steps/index.js